// Mirror of @ai-agent-widget/shared/messages.ts MESSAGE_TYPES.{READY, PREVIEW_*}.
// No build-time dependency between repos; keep in sync manually.
//
// Canonical source: ai-agent-widget/shared/src/messages.ts
//
// When the widget's contract evolves, audit these four strings:
//   - READY:                 widget → backoffice, single-shot
//   - PREVIEW_INIT:          backoffice → widget, single-shot,
//                            payload { config, state, invite? }
//   - PREVIEW_CONFIG_UPDATE: backoffice → widget, debounced, payload { config }
//   - PREVIEW_STATE_CHANGED: backoffice → widget, immediate,
//                            payload { state, invite? }
// Drift symptom: silent no-op (messages with unrecognised `type` are ignored
// by both sides), so a typo here surfaces as "preview doesn't update" not as
// a stack trace.
//
// `invite` is the sample text for the proactive invite card (RPAA-279). It
// travels on the state channel and not inside `config` because it is NOT
// tenant configuration: in production the text arrives on the host page's
// `kodly-ai-agent:invite` event. Nobody saves it here, and a field in the
// settings form would invent a setting that does not exist.

export const WIDGET_MESSAGE_TYPES = {
  READY: "kodly-ai-agent.ready",
  PREVIEW_INIT: "kodly-ai-agent.preview-init",
  PREVIEW_CONFIG_UPDATE: "kodly-ai-agent.preview-config-update",
  PREVIEW_STATE_CHANGED: "kodly-ai-agent.preview-state-changed",
};
